module.exports = __webpack_public_path__ + "img/2.adc27cb8.png";